import React, { useEffect, useState } from "react";
import {
  Box,
  Text,
  Button,
  Grid,
  Label,
  Flex,
  Modal,
  ErrorMsg,
} from "atoms";
import { FormInput, FormSelect } from "molecules";
import * as Yup from "yup";
import { Formik, Form } from "formik";
import MemoClose from "assets/icons/Close";
import { InvitationSentModal } from "molecules/Modals";
import { optionFetch } from "utils/utilities";

export const AddNewTypologyModal = ({
  isOpen,
  onClose,
  title,
  preRecord,
  onSubmit,
  loading,
  error,
  resetError,
}) => {
  const [isConfirmModalVisible, setConfirmModalVisible] = useState(false);

  // type
  const [apiPropertyTypes, setApiPropertyTypes] = useState([]);

  useEffect(() => {
    // type
    optionFetch("/propertytypes/get", "name", "id").then((data) => {
      setApiPropertyTypes(data);
    });
  }, []);

  return (
    <>
      <Modal isOpen={isOpen} onClose={onClose}>
        <Box width={{ md: "50rem" }}>
          <Box p={{ xs: "2.4rem", lg: "3.2rem" }}>
            <Flex
              justifyContent="space-between"
              borderBottom="0.1rem solid"
              borderColor="neutral.100"
              pb="2.4rem"
            >
              <Text
                fontSize="2rem"
                color="primary.900"
                fontFamily="primaryBold"
              >
                {preRecord ? "Edit" : "Add New"} {title || ""}
              </Text>
              <Box
                color="neutral.900"
                onClick={onClose}
                cursor="pointer"
                textAlign="right"
              >
                <MemoClose height="1.6rem" width="1.6rem" />
              </Box>
            </Flex>
            <Formik
              initialValues={{
                name: preRecord?.name || "",
                propertyTypes: preRecord?.propertyTypes || [],
              }}
              onSubmit={onSubmit}
              validationSchema={Yup.object().shape({
                name: Yup.string().required("Name is required"),
                propertyTypes: Yup.array()
                  .min(1, "Property Type is required")
                  .typeError("Property Type is required")
                  .required("Property Type is required"),
              })}
            >
              {({ values, setFieldValue, touched, errors }) => {

                return (
                  <Form>
                    <Grid gridRowGap="2.4rem" mt="1.8rem">
                      <Grid gridRowGap="1.6rem">
                        <Label text="Name" req />
                        <FormInput
                          name="name"
                          placeholder="Enter Name"
                          req
                          onChange={(e) => {
                            setFieldValue("name", e?.target?.value);
                            error && resetError();
                          }}
                        />
                      </Grid>

                      <Grid gridRowGap="1.6rem">
                        <Label text="Property Type" req />
                        <FormSelect
                          name="propertyTypes"
                          placeholder="Select Property Type"
                          options={apiPropertyTypes}
                          req
                          onChange={(e) => {
                            // setFieldValue("name", e?.target?.value);
                            error && resetError();
                          }}
                          isMulti
                        />
                      </Grid>

                      {error && <ErrorMsg text={error} />}

                      <Button
                        variant="primary"
                        type="submit"
                        height={{ xs: "4.3rem", lg: "4.8rem" }}
                        loading={loading}
                      >
                        Save
                      </Button>
                    </Grid>
                  </Form>
                );
              }}
            </Formik>
          </Box>
        </Box>
      </Modal>
      {isConfirmModalVisible && (
        <InvitationSentModal
          isOpen={isConfirmModalVisible}
          onClose={() => setConfirmModalVisible(false)}
        />
      )}
    </>
  );
};
